import React from 'react';
import styled from 'styled-components';
import MaterialTable from "material-table";
import moment from 'moment';
import numeral from 'numeral';
import {Link} from 'react-router-dom'
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Warning from '@material-ui/icons/Warning';
import Error from '@material-ui/icons/Error';
import Face from '@material-ui/icons/Face';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { BACKGROUND_COLOR, BLACK_COLOR, BLUE_COLOR, RED_COLOR } from '../config/color';
import CanvasJSReact from '../config/canvas/canvasjs.react';

import {Line} from 'react-chartjs-2';
import { Rotate90DegreesCcw } from '@material-ui/icons';

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;


const ImageContainer = styled.div`
  width: 2rem;
  /* height: 3rem; */
  margin-right: .7rem;
`

const MainSectionTitle = styled.p`
  font-weight: 600;
  color: ${BLACK_COLOR};
  font-size: 0.73rem;
`;

const MainSectionSubTitle = styled.p`
  font-weight: 400;
  color: ${BLACK_COLOR};
  font-size: 0.73rem;
  margin-top: 5px;
`;


const PriceText = styled.p`
  font-weight: 400;
  /* color: #77838f !important; */
  margin-right: 10px;
  color: ${BLACK_COLOR};
  font-size: 0.73rem;
`;

const ComparisonColor = styled.p`
  font-weight: 400;
  /* color: #77838f !important; */
  color: ${props => (props.color > 0 ? `${RED_COLOR}` : props.color === 0 ? `${BLACK_COLOR}` : `${BLUE_COLOR}`)} ;
  font-size: 0.73rem;
`;

const DataTableWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 575px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const DataTablePriceWrap = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 575px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const DataTableHighAndLowPriceWrap = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 575px) {
    flex-direction: row;
  }
`

const DataTableMedianPriceWrap = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 575px) {
    flex-direction: row;
    margin-top: 10px;
  }
`

const DetailPanelWrap = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 575px) {
    padding: 10px;
  }
`

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Error: forwardRef((props, ref) => <Error {...props} ref={ref} />),
  Face: forwardRef((props, ref) => <Face {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  Warning: forwardRef((props, ref) => <Warning {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
  
};

const columns = [
  // {
  //   title: "이미지",
  //   field: "image",
  //   render: rowData => {
  //     return (
  //       <ImageContainer>
  //         <img style={{width: '100%', resizeMode: "contain" }} src={rowData.image} />
  //       </ImageContainer>
  //     );
  //   }
  // },
  {
    field: "name",
    render: rowData => {
      const latesMedianhPrice = (rowData.medianPrice[rowData.medianPrice.length - 1])
      const comparPrice = rowData.medianPrice.length < 2 ? 0 : ( (rowData.medianPrice[rowData.medianPrice.length - 1] - rowData.medianPrice[rowData.medianPrice.length - 2]));
      const latestHighPrice = (rowData.highPrice[rowData.highPrice.length - 1])
      const latestLowPrice = (rowData.lowPrice[rowData.lowPrice.length - 1])
      return (
        <DataTableWrap>
          <div style={{flex: 1, display: 'flex', alignItems: 'center'}}>
            <div>
              <ImageContainer>
                <img style={{width: '100%', resizeMode: "contain" }} src={rowData.image} />
              </ImageContainer>
            </div>
            <div>
              {/* <MainSectionTitle style={{color: '#8A8A8A'}}>
                {rowData.category2}
              </MainSectionTitle> */}
              <MainSectionTitle>
                {rowData.name}
              </MainSectionTitle>
              <MainSectionSubTitle>
                {rowData.category3}
              </MainSectionSubTitle>
            </div>
          </div>
          <DataTablePriceWrap>
            <DataTableMedianPriceWrap>
              <PriceText>
                기준가: 
              </PriceText>
              <PriceText style={{fontWeight: 600}}>
                {numeral(latesMedianhPrice).format('0,0')}원
              </PriceText>
              {comparPrice > 0 ? (
                <ComparisonColor color={comparPrice} style={{display: 'flex', alignItems: 'center'}}>
                  <PlayArrowIcon style={{transform: 'rotate(270deg)', fontSize: 14}} />
                  <p>
                    {numeral(comparPrice).format('0,0')}원
                  </p>
                </ComparisonColor>
              ) : comparPrice === 0 ? (
                <ComparisonColor color={comparPrice} >
                  -
                </ComparisonColor>
              ) : (
                <ComparisonColor style={{display: 'flex', alignItems: 'center'}}>
                  <PlayArrowIcon style={{transform: 'rotate(90deg)', fontSize: 14}} />
                  <p>
                    {numeral(comparPrice).format('0,0')}원
                  </p>
                </ComparisonColor>
              )}
              
            </DataTableMedianPriceWrap>
            <DataTableHighAndLowPriceWrap>
              <PriceText>
                최고 평균 기준가: 
              </PriceText>
              <PriceText>
                {numeral(latestHighPrice).format('0,0')}원
              </PriceText>
            </DataTableHighAndLowPriceWrap>
            <DataTableHighAndLowPriceWrap>
              <PriceText>
                최저 평균 기준가: 
              </PriceText>
              <PriceText>
                {numeral(latestLowPrice).format('0,0')}원
              </PriceText>
            </DataTableHighAndLowPriceWrap>
          </DataTablePriceWrap>
        </DataTableWrap>
      );
    }
  },
  // {
  //   title: "기준가",
  //   field: "medianPrice",
  //   render: rowData => {
  //     const latesMedianhPrice = (rowData.medianPrice[rowData.medianPrice.length - 1])
  //     const comparPrice = rowData.medianPrice.length < 2 ? 0 : ( (rowData.medianPrice[rowData.medianPrice.length - 1] - rowData.medianPrice[rowData.medianPrice.length - 2]));
  //     return (
  //       <div style={{display: 'flex', flexDirection: 'column'}}>
  //         <PriceText>
  //           {numeral(latesMedianhPrice).format('0,0')}원
  //         </PriceText>
  //         <ComparisonColor color={comparPrice} >
  //           ({numeral(comparPrice).format('0,0')})
  //         </ComparisonColor>
  //       </div>
  //     );
  //   }
  // },
  // {
  //   title: "최고 평균 기준가",
  //   field: "highPrice",
  //   render: rowData => {
  //     const latestHighPrice = (rowData.highPrice[rowData.highPrice.length - 1])
  //     return (
  //       <div style={{display: 'flex', flexDirection: 'column'}}>
  //         <PriceText>
  //           {numeral(latestHighPrice).format('0,0')}원
  //         </PriceText>
  //       </div>
  //     );
  //   }
  // },
  // {
  //   title: "최저 평균 기준가",
  //   field: "lowPrice",
  //   render: rowData => {
  //     const latestLowPrice = (rowData.lowPrice[rowData.lowPrice.length - 1])
  //     return (
  //       <div style={{display: 'flex', flexDirection: 'column'}}>
  //         <PriceText>
  //           {numeral(latestLowPrice).format('0,0')}원
  //         </PriceText>
  //       </div>
  //     );
  //   }
  // },
];

const BlockContainerWrap = styled.div`
  width: 100%;
`;

const BlockContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TextBokx = styled.p`
  font-size: .8125rem;
  width: 2.53906rem;
  height: 2.53906rem;
  padding: 0;
  color: #77838f;
  /* background: rgba(119,131,143,.1); */
  border-radius: 50%!important;
  margin-right: .5rem!important;
`

const BlockTitle = styled.h1`
  font-size: 1.21875rem;
  border-bottom: 1px solid #e7eaf3 !important;
  padding-bottom: 0.75rem !important;
`;

const BlueColor = styled(Link)`
    color: #3498db;
    cursor: pointer;
    font-weight: 600;
`;

const BlockTopArticle = styled.div`
  /* width: 1064px; */
  width: 100%;
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
  padding-left: 15px;
  padding-right: 15px;
`;

const BlockBox = styled.div`
  margin-top: 0.75rem !important;
  box-shadow: 0 0.5rem 1.2rem rgba(189, 197, 209, 0.2);
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #e7eaf3;
  border-radius: 0.5rem;
`;

const BlockBoxTable = styled.div`
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0.75rem;

  .MuiTableFooter-root {
    /* display: none !important; */
  }
  .MuiTableCell-root {
    /* padding: 16px 0; */
  }
`;

const SpaceBetween = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e7eaf3 !important;
  padding-bottom: 0.75rem !important;
`

const ListTitle = styled.h1`
  font-size: 1.21875rem;
`;

const RightMargin = styled.div`
  min-width: 20%;
  max-width: 20%;
  margin-right: 3rem;
  @media (max-width: 575px) {
    min-width: 50%;
    max-width: 50%;
    margin-right: 0;
    margin-bottom: 20px;
  }
`

// Detail

const DetailTopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 1.5rem 3rem;
  border: 5px solid #E7E7E7;
  margin-bottom: 20px;
  @media (max-width: 575px) {
    flex-direction: column;
    padding: 1rem 1rem;
  }
`

const DetailBrandText = styled.p`
  font-weight: 600;
  color: ${BLACK_COLOR};
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 10px;
  @media (max-width: 575px) {
    font-size: 14px;
    margin-bottom: 5px;
    line-height: 14px;
  }
`

const DetailModelText = styled.p`
  font-weight: 400;
  color: #8A8A8A;
  margin-bottom: 10px;
`

const DetailPriceTextWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 10px;
  @media (max-width: 575px) {
    justify-content: flex-start;
    align-items: flex-start;
  }
`

const RecentMedianPriceText = styled.p`
  font-weight: 600;
  color: #2ea4d9;
  font-size: 24px;
  line-height: 26px;
  margin-right: 5px;
  @media (max-width: 575px) {
    font-size: 16px;
    line-height: unset;
  }
`

const RecentMedianPriceWrap = styled.div`
  display: flex;
  margin-left: 10px;
  justify-content: flex-end;
  align-items: flex-end;
  @media (max-width: 575px) {
    justify-content: flex-end;
    align-items: center;
  }
`

const RecentMedianPriceDateText = styled.p`
  font-weight: 400;
  color: #8A8A8A;
  font-size: 12px;
`

const RecentHighAndRowPriceWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`

const RecentHighAndRowPriceText = styled.p`
  font-size: 16px;
  color: #8A8A8A;
  line-height: 24px;
  letter-spacing: 0.5;
  font-weight: 400;
  margin-right: 5px;
  @media (max-width: 575px) {
    font-size: 12px;
    line-height: unset;
  }
`


export default (props) => {
  const {getWatchDataList} = props?.getWatchData;

  const today = moment().format('YYYY-MM-DD');
  
  return (
    <BlockContainerWrap>
      <BlockContainer>
        <BlockTopArticle>
          {/* <SpaceBetween>
            <ListTitle>
              오늘의 가격
            </ListTitle>
            <ListTitle>
              {today} 기준
            </ListTitle>
          </SpaceBetween> */}
          <BlockBox>
            <BlockBoxTable>
              <MaterialTable
                title="오늘의 가격"
                icons={tableIcons}
                style={{ boxShadow: "none" }}
                columns={columns}
                data={getWatchDataList}
                options={{
                  search: true,
                  pageSize: 10,
                  // toolbar: false,
                  headerStyle: {
                    // backgroundColor: "#F8FAFD",
                    fontWeight: "bold",
                    color: "#6c757e",
                    paddingTop: 5,
                    paddingBottom: 5,
                    fontSize: 12
                  },
                  rowStyle: {
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontSize: 12
                  }
                }}
                detailPanel={rowData => {
                  const recentlyHighPrice = numeral(rowData.highPrice[rowData.highPrice.length - 1]).format('0,0')
                  const recentlyMedianPrice = numeral(rowData.medianPrice[rowData.medianPrice.length - 1]).format('0,0')
                  const recentlyLowPrice = numeral(rowData.lowPrice[rowData.lowPrice.length - 1]).format('0,0')
                  return (
                    <DetailPanelWrap>
                      <DetailTopSection>
                        <RightMargin>
                          <img style={{width: '100%'}} src={rowData.image} />
                        </RightMargin>
                        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', width: '100%'}}>
                          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                            <DetailBrandText>
                              {rowData.name}
                            </DetailBrandText>
                          </div>
                          <DetailModelText>
                            {rowData.category2}
                          </DetailModelText>
                          <div style={{display: 'flex', marginBottom: 10, justifyContent: 'flex-end', alignItems: 'flex-end'}}>
                            <p>
                              모델명:
                            </p>
                            <p style={{marginLeft: 10, fontWeight: 600, color: 'rgb(75, 76, 81)'}}>
                              {rowData.category3}
                            </p>
                          </div>
                          <DetailPriceTextWrap>
                            <p style={{fontWeight: 400}}>
                              시세:
                            </p>
                            <RecentMedianPriceWrap>
                              <div style={{display: 'flex', alignItems: 'flex-end'}}>
                                <RecentMedianPriceText>
                                  {recentlyMedianPrice}
                                </RecentMedianPriceText>
                                <p style={{ fontWeight: 400, marginRight: 10}}>
                                  원
                                </p>
                              </div>
                              <RecentMedianPriceDateText>
                                ({rowData.dateTrend[rowData.dateTrend.length - 1]}) 기준
                              </RecentMedianPriceDateText>
                            </RecentMedianPriceWrap>
                          </DetailPriceTextWrap>
                          <RecentHighAndRowPriceWrap>
                            <RecentHighAndRowPriceText>
                              ({recentlyHighPrice} ~ {recentlyLowPrice})
                            </RecentHighAndRowPriceText>
                            <RecentHighAndRowPriceText>
                              하위평균 ~ 상위평균
                            </RecentHighAndRowPriceText>
                          </RecentHighAndRowPriceWrap>
                        </div>
                      </DetailTopSection>
                      <div style={{flex: 1}}>
                        <Line data={{
                          labels: rowData.dateTrend,
                          datasets: [
                            {
                              label: '상위 평균',
                              fill: false,
                              lineTension: 0.5,
                              backgroundColor: 'rgb(199, 248, 240)',
                              borderColor: 'rgb(199, 248, 240)',
                              borderCapStyle: 'butt',
                              borderDash: [],
                              borderDashOffset: 0.0,
                              borderJoinStyle: 'miter',
                              pointBorderColor: 'rgb(199, 248, 240)',
                              pointBackgroundColor: '#fff',
                              pointBorderWidth: 1,
                              pointHoverRadius: 5,
                              pointHoverBackgroundColor: 'rgb(199, 248, 240)',
                              pointHoverBorderColor: 'rgba(220,220,220,1)',
                              pointHoverBorderWidth: 2,
                              pointRadius: 1,
                              pointHitRadius: 10,
                              borderWidth: 1,
                              data: rowData.highPrice
                            },
                            {
                              label: '평균 시세',
                              fill: false,
                              lineTension: 0.5,
                              backgroundColor: '#56afe4',
                              borderColor: '#56afe4',
                              borderCapStyle: 'butt',
                              borderDash: [],
                              borderDashOffset: 0.0,
                              borderJoinStyle: 'miter',
                              pointBorderColor: '#56afe4',
                              pointBackgroundColor: '#fff',
                              pointBorderWidth: 1,
                              pointHoverRadius: 5,
                              pointHoverBackgroundColor: '#56afe4',
                              pointHoverBorderColor: 'rgba(220,220,220,1)',
                              pointHoverBorderWidth: 2,
                              pointRadius: 1,
                              pointHitRadius: 10,
                              data: rowData.medianPrice
                            },
                            {
                              label: '하위 평균',
                              fill: false,
                              lineTension: 0.5,
                              backgroundColor: 'rgb(227, 227, 238)',
                              borderColor: 'rgb(227, 227, 238)',
                              borderCapStyle: 'butt',
                              borderDash: [],
                              borderDashOffset: 0.0,
                              borderJoinStyle: 'miter',
                              pointBorderColor: 'rgb(227, 227, 238)',
                              pointBackgroundColor: '#fff',
                              pointBorderWidth: 1,
                              pointHoverRadius: 5,
                              pointHoverBackgroundColor: 'rgb(227, 227, 238)',
                              pointHoverBorderColor: 'rgba(220,220,220,1)',
                              pointHoverBorderWidth: 2,
                              pointRadius: 1,
                              pointHitRadius: 10,
                              borderWidth: 1,
                              data: rowData.lowPrice
                            },
                          ]
                        }}
                        options={
                          {
                            legend:{
                              display: false
                            },
                            scales: {
                              yAxes: [{
                                scaleLabel: {
                                },
                                ticks: {
                                  callback: function(label, index, labels) {
                                    return label.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
                                  }
                                },
                              }],
                              xAxes: [{
                                scaleLabel: {
                                }
                              }],
                            },
                            tooltips: { 
                              mode: 'label', 
                              label: 'mylabel',
                              callbacks: { 
                                label: function(tooltipItem, data) {
                                  return data.datasets[tooltipItem.datasetIndex].label+' '+tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+" 원"; }, }, 
                              }
                            }
                          }
                        />
                      </div>
                    </DetailPanelWrap>
                  )
                }}
              />
            </BlockBoxTable>
          </BlockBox>
        </BlockTopArticle>
      </BlockContainer>
    </BlockContainerWrap>
  )
}